import cadPng from "../LandingPageImages/CAD_Automation.png";
import cadWebp from "../LandingPageImages/CAD_Automation.webp";
import automotivePng from "../LandingPageImages/Automotive.png";
import automotiveWebp from "../LandingPageImages/Automotive.webp";
import aimlPng from "../LandingPageImages/AIML.png";
import aimlWebp from "../LandingPageImages/AIML.webp";
import cvPng from "../LandingPageImages/CV.png";
import cvWebp from "../LandingPageImages/CV.webp";
import fullstackPng from "../LandingPageImages/Fullstack1.png";
import fullstackWebp from "../LandingPageImages/Fullstack1.webp";
import digitalPng from "../LandingPageImages/digital_marketing.png";
import digitalWebp from "../LandingPageImages/digital_marketing.webp";
import plmPng from "../LandingPageImages/PLM.png";
import plmWebp from "../LandingPageImages/PLM.webp";

/**
 * The seven service sections on the home page.
 *
 * These were previously seven near-identical components, each with its own
 * copy-pasted CSS block that had drifted apart — which is why they did not line
 * up with one another. They now share one component and one stylesheet; only
 * the content differs.
 *
 * Image side and background tint alternate by index, so adding a section keeps
 * the rhythm automatically instead of needing another bespoke CSS rule.
 */
const useCases = [
  {
    id: "cad-automation",
    title: "CAD Automation and Customization: Streamline Your Design Process",
    body: "Elevate your projects with our CAD automation and customization services. Tailored for the automotive, aerospace, railway and energy sectors, we enhance design efficiency and precision, helping you deliver innovative solutions faster — improving safety, modernizing engineering and optimizing resources, all while reducing costs.",
    bullets: [
      "Parametric Design Automation",
      "Customization of CAD Environment",
      "Automated Drawing Generation",
      "Data Migration",
      "Integration with PLM and ERP Systems",
    ],
    href: "/cadautomation",
    img: cadPng,
    webp: cadWebp,
    width: 502,
    height: 497,
    alt: "Parametric CAD model being generated automatically from a design template",
  },
  {
    id: "automotive-design",
    title: "Innovating Automotive Design: CAD Solutions for the Future of Mobility",
    body: "Our automotive CAD solutions enable manufacturers to create highly efficient and precise designs for modern vehicles. From prototyping to production, our automation tools ensure accuracy and speed.",
    bullets: [
      "3D Vehicle Modeling",
      "Automated Component Assembly",
      "CAD Customization for Automotive Standards",
      "Integration with Automotive Engineering Tools",
    ],
    href: "/automotivedesign",
    img: automotivePng,
    webp: automotiveWebp,
    width: 663,
    height: 376,
    alt: "Three-dimensional CAD model of a vehicle body under design review",
  },
  {
    id: "ai-ml",
    title: "Unlock Innovation: AI/ML Solutions for Data-Driven Decision Making",
    body: "Our AI and machine learning services empower your business to harness the power of data — automating processes, enhancing predictions and driving actionable insights. From predictive models to intelligent automation, we build custom solutions that accelerate your digital transformation.",
    bullets: [
      "Predictive Analytics for Market Trends",
      "Automated Data Processing and Analysis",
      "AI-Powered Customer Behavior Insights",
      "Integration with IoT and Cloud Platforms",
    ],
    href: "/aiml",
    img: aimlPng,
    webp: aimlWebp,
    width: 601,
    height: 561,
    alt: "Neural network diagram illustrating a machine learning model in training",
  },
  {
    id: "computer-vision",
    title: "Revolutionizing Computer Vision: AI-Powered Solutions for Visual Recognition",
    body: "Our computer vision solutions enable businesses to harness AI for accurate, real-time visual recognition. From image analysis to object detection, our tools are designed to enhance efficiency and precision across industries.",
    bullets: [
      "Automated Image Recognition",
      "Real-time Object Detection",
      "AI-based Image Processing and Enhancement",
      "Integration with Machine Learning Models",
    ],
    href: "/computervision",
    img: cvPng,
    webp: cvWebp,
    width: 510,
    height: 300,
    alt: "Computer vision model drawing bounding boxes around detected objects",
  },
  {
    id: "full-stack",
    title: "Empowering Full Stack Development: End-to-End Web and Application Solutions",
    body: "Our full stack development services offer comprehensive solutions for building dynamic, scalable web and mobile applications. From front-end interfaces to back-end infrastructure, we ensure seamless integration and performance.",
    bullets: [
      "Responsive Frontend Development",
      "Robust Backend Architecture",
      "API Integration and Development",
      "Database Design and Optimization",
    ],
    href: "/fullstack",
    img: fullstackPng,
    webp: fullstackWebp,
    width: 1157,
    height: 783,
    alt: "Full stack application architecture spanning browser, API and database layers",
  },
  {
    id: "digital-marketing",
    title: "Driving Success in Digital Marketing: Data-Driven Campaigns for Maximum Reach",
    body: "Our digital marketing solutions leverage data and analytics to create targeted campaigns that engage your audience and drive results. From SEO to social media management, we offer comprehensive strategies to enhance your brand's online presence.",
    bullets: [
      "Search Engine Optimization (SEO)",
      "Social Media Marketing",
      "Pay-Per-Click (PPC) Campaigns",
      "Content Creation and Strategy",
    ],
    href: "/digitalmarketing",
    img: digitalPng,
    webp: digitalWebp,
    width: 577,
    height: 433,
    alt: "Digital marketing analytics dashboard tracking campaign reach and engagement",
  },
  {
    id: "plm",
    title: "Streamlining Innovation with PLM Solutions: Managing the Entire Product Lifecycle",
    body: "Our PLM solutions provide end-to-end management for product development, ensuring seamless collaboration across teams and optimizing every stage of the product lifecycle. From concept to production, we enable businesses to innovate faster and more efficiently.",
    bullets: [
      "Comprehensive Product Data Management",
      "Collaboration Across Design and Engineering Teams",
      "Lifecycle Workflow Automation",
      "Integration with CAD and ERP Systems",
    ],
    href: "/plmsolution",
    img: plmPng,
    webp: plmWebp,
    width: 1044,
    height: 1043,
    alt: "Product lifecycle management workflow connecting design, engineering and production data",
  },
];

export default useCases;
